import { Component, OnInit } from '@angular/core';

import { ModalController, Platform } from '@ionic/angular';
// import { ViewerModalComponent } from 'ngx-ionic-image-viewer';
import { PhotoViewer } from '@ionic-native/photo-viewer/ngx';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';
import { PhotoViewerPage } from '../photo-viewer/photo-viewer.page';
// import { DomSanitizer } from '@angular/platform-browser';
// export interface PhotoViewerOptions {
//   share?: boolean;
//   closeButton?: boolean;
//   copyToReference?: boolean;
//   headers?: string;
//   piccasoOptions?: {
//       fit?: boolean;
//       centerInside?: boolean;
//       centerCrop?: boolean;
//   };
// }
@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.page.html',
  styleUrls: ['./gallery.page.scss'],
})
export class GalleryPage implements OnInit {
  businessDetail: any;
  images =[];
  isDataLoaded=false;
  config={
    btnClass: 'default', // The CSS class(es) that will apply to the buttons
    zoomFactor: 0.1, // The amount that the scale will be increased by
    containerBackgroundColor: '#ccc', // The color to use for the background. This can provided in hex, or rgb(a).
    wheelZoom: true, // If true, the mouse wheel can be used to zoom in
    allowFullscreen: false, // If true, the fullscreen button will be shown, allowing the user to entr fullscreen mode
    allowKeyboardNavigation: true, // If true, the left / right arrow keys can be used for navigation
    btnIcons: { // The icon classes that will apply to the buttons. By default, font-awesome is used.
      zoomIn: 'fa fa-plus',
      zoomOut: 'fa fa-minus',
      rotateClockwise: 'fa fa-repeat',
      rotateCounterClockwise: 'fa fa-undo',
      next: 'fa fa-arrow-right',
      prev: 'fa fa-arrow-left',
      fullscreen: 'fa fa-arrows-alt',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      rotateClockwise: true,
      rotateCounterClockwise: true,
      next: true,
      prev: true
    }
  };
  megaImage: any;

  constructor(
    
    public modalController: ModalController,
    private photoViewer: PhotoViewer,
    private platform: Platform,
    public globals:GlobalVariable,
    public server:UserApiService,
    // public domSanit:DomSanitizer,

  ) {}

  ngOnInit() {
    // this.storage.get('resData').then((res) => {
    //   this.businessDetail = res;
    // });
  }
  ionViewWillEnter(){
    
    this.get_gallery();
  }
  // getSafeUrl(){
  //   let link='https://ittone.ma/ittone/ionic5-how-to-embed-website-via-iframe-in-ionic-app/'
  //   return this.domSanit.bypassSecurityTrustResourceUrl(link) ;
  // }
  showImage(imageData) {
    this.megaImage=imageData.image
    // console.log('img', imageData);
    // if (this.platform.is('ios')) {
    //   imageData.img = decodeURIComponent(imageData.image);
    // }
    // this.photoViewer.show(imageData.image, '', { share: true });
  }
  async photoView(image){
   const modal=await this.modalController.create({
      component:PhotoViewerPage,
      componentProps:{image:image},
      cssClass:'galleryModal',
    })
    modal.present();
  }

  get_gallery() {
    let response = this.server.gallery_list();
    response.subscribe(data => {
      this.isDataLoaded=true;
      if(data.status=='OK'){
        console.log("gallery",data);
        if(data.data){
          this.images = data.data.blogs;
          this.megaImage=this.images[0].image;
        }
      }
    }, error => {
        this.globals.presentToast("Something went wrong check your internet connection.");

    });
}
  // async showImage(img) {
  //   const modal = await this.modalController.create({
  //     component: ViewerModalComponent,
  //     componentProps: {
  //       src: img
  //     },
  //     cssClass: 'ion-img-viewer',
  //     keyboardClose: true,
  //     showBackdrop: true
  //   });

  //   return await modal.present();
  // }
}
